import { render, staticRenderFns } from "./SnippetEmailForm.vue?vue&type=template&id=04ab416a&scoped=true&"
import script from "./SnippetEmailForm.vue?vue&type=script&lang=js&"
export * from "./SnippetEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab416a",
  null
  
)

export default component.exports